export default __webpack_public_path__ + "static/media/user.9edf34e0.svg";